import React from "react";
import { Button, Box } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

function ButtonSection({
  handleSaveNextDefault,
  handleMarkReviewDefault,
  currentQuestion,
  handleClearResponse,
  setOptionId,
  handleBack,
  isLast,
  handleOpenSubmitModal,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row", // Keep row layout to place Back button on the side
        justifyContent: "space-between",
        alignItems: "center",
        padding: { xs: "8px 6px", sm: "10px 20px" },
        borderTop: "1px solid #e0e0e0",
        background: "#fff",
        flexShrink: 0,
        position: { xs: "fixed", md: "sticky" },
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        zIndex: 1000,
        boxShadow: { xs: "0 -4px 12px rgba(0,0,0,0.1)", md: "none" },
        gap: { xs: 0.5, md: 2 },
        boxSizing: "border-box",
      }}
    >
      {/* Left side: Back Button */}
      <Box sx={{ display: "flex", gap: { xs: "8px", sm: "10px" }, alignItems: "center", flexWrap: "nowrap" }}>
        <Box
          onClick={currentQuestion > 0 ? handleBack : null}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: currentQuestion > 0 ? "pointer" : "default",
            width: { xs: 32, sm: 40 },
            height: { xs: 32, sm: 40 },
            borderRadius: "50%",
            backgroundColor: "#f5f5f5",
            opacity: currentQuestion > 0 ? 1 : 0.5,
            "&:hover": { backgroundColor: currentQuestion > 0 ? "#eeeeee" : "#f5f5f5" },
            transition: "all 0.2s"
          }}
        >
          <ArrowBackIosNewIcon
            sx={{ fontSize: { xs: 16, sm: 20 }, color: currentQuestion > 0 ? "#555" : "#ccc", flexShrink: 0, ml: "4px" }}
          />
        </Box>
      </Box>

      {/* ── Button Grid (2x2 on Mobile) ── */}
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          gap: { xs: 0.8, sm: 2 },
          flex: 1,
        }}
      >
        {/* Pair 1: Reset & Review */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 1,
            flex: { xs: 1, md: "0 1 auto" },
          }}
        >
          <Button
            onClick={() => {
              handleClearResponse();
              setOptionId("");
            }}
            size="small"
            variant="outlined"
            color="inherit"
            sx={{
              textTransform: "none",
              fontSize: { xs: "0.7rem", sm: "0.8rem" },
              py: { xs: 0.7, sm: 1 },
              width: { xs: "100%", md: "110px" },
              whiteSpace: "nowrap",
            }}
          >
            Reset
          </Button>
          <Button
            onClick={async () => {
              await handleMarkReviewDefault("marked");
            }}
            size="small"
            variant="outlined"
            sx={{
              textTransform: "none",
              fontSize: { xs: "0.7rem", sm: "0.8rem" },
              py: { xs: 0.7, sm: 1 },
              width: { xs: "100%", md: "110px" },
              borderColor: "#f0ad4e",
              color: "#e65100",
              whiteSpace: "nowrap",
            }}
          >
            Review
          </Button>
        </Box>

        {/* Pair 2: Save & Next + Save */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 1,
            flex: { xs: 1, md: "0 1 auto" },
          }}
        >
          <Button
            onClick={() => handleSaveNextDefault(false)}
            size="small"
            variant="outlined"
            sx={{
              textTransform: "none",
              fontSize: { xs: "0.7rem", sm: "0.8rem" },
              py: { xs: 0.7, sm: 1 },
              width: { xs: "100%", md: "130px" },
              borderColor: "#1976d2",
              color: "#1976d2",
              whiteSpace: "nowrap",
              order: { xs: 2, md: 1 }
            }}
          >
            <Box component="span" sx={{ display: { xs: "inline", sm: "none" } }}>Save</Box>
            <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>Save Response</Box>
          </Button>

          <Button
            onClick={async () => {
              if (isLast) {
                const saved = await handleSaveNextDefault(false);
                if (saved !== false) {
                  handleOpenSubmitModal();
                }
              } else {
                await handleSaveNextDefault();
              }
            }}
            size="small"
            variant="contained"
            sx={{
              textTransform: "none",
              fontSize: { xs: "0.7rem", sm: "0.8rem" },
              py: { xs: 0.7, sm: 1 },
              width: { xs: "100%", md: "130px" },
              background: "#1976d2",
              "&:hover": { background: "#1565c0" },
              whiteSpace: "nowrap",
              order: { xs: 1, md: 2 }
            }}
          >
            {isLast ? "Submit" : "Save & Next"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default ButtonSection;
